import {readable} from "svelte/store";

import {IDS, sectionViewsMap} from "./layers";
import {default as horizontalBarChart} from '../../notebooks/horizontal-bar-chart'
import {default as treeMap} from '../../notebooks/tree-map'
import {default as bubbleMap} from '../../notebooks/bubble-map'
import {default as table} from '../../notebooks/table'

const BAR_CHART = 'bar chart';
const TREEMAP = 'tree map';
const BUBBLEMAP = 'bubble';
const TABLE = 'table';

function defaultViews(aReport, sectionUuid, layerId, areaAggregateQueryFn) {
    const query = areaAggregateQueryFn(aReport, layerId);
    const overrides = new Map([['rawData', query.request]]);

    const cells = ['chart'];

    const views = sectionViewsMap.get(sectionUuid);

    return [
        {
            title: BAR_CHART,
            id: views.find(v => v.title === BAR_CHART).id,
            notebook: horizontalBarChart,
            cells,
            extraClass: 'area-report-horizontal-bar-chart',
            retry: query.retryStore || readable(false, () => {
            }),
            overrides//: barChartOverrides
        },
        {
            title: TREEMAP,
            id: views.find(v => v.title === TREEMAP).id,
            notebook: treeMap,
            cells,
            extraClass: 'area-report-tree-map',
            retry: query.retryStore || readable(false, () => {
            }),
            overrides
        },
        {
            title: BUBBLEMAP,
            id: views.find(v => v.title === BUBBLEMAP).id,
            notebook: bubbleMap,
            cells,
            extraClass: 'area-report-bubble-map',
            retry: query.retryStore || readable(false, () => {
            }),
            overrides
        },
        {
            title: TABLE,
            id: views.find(v => v.title === TABLE).id,
            notebook: table,
            cells: ['table'],
            extraClass: 'area-report-table',
            retry: query.retryStore || readable(false, () => {
            }),
            overrides
        }
    ]
}


function section(aReport, section, layerId, areaAggregateQueryFn) {
    if (!areaAggregateQueryFn) {
        throw new Error(`${section} ${layerId}`)
    }

    return {
        ...section,
        notebookViews: defaultViews(aReport, section.uuid, layerId, areaAggregateQueryFn)
    }
}

export function areaReportTopics(report, areaAggregateQueryFn) {
    return [
        {
            title: 'Landscape',
            topics: [
                {
                    title: 'Direction of slope (Aspect)',
                    id: '96e55b7c-e9dc-4b7f-9236-e847aed43b74',
                    sections: [
                        section(report, {
                            uuid: 'c67a8cee-eba5-4744-82b1-e2bfc60d507f'/*,
                            notebookViews: defaultViews(report, IDS.SLOPE_ASPECT)*/
                        }, IDS.SLOPE_ASPECT, areaAggregateQueryFn)
                    ]
                },
                {
                    title: 'Steepness of Slope',
                    id: 'b8ea9e9b-7d8f-4225-80e4-69128d637e83',
                    sections: [
                        section(report, {
                            uuid: '358ad3c9-e4c4-4d39-9d0e-4d67b563d889'/*,
                            notebookViews: defaultViews(report, IDS.SLOPE_STEEPNESS)*/
                        }, IDS.SLOPE_STEEPNESS, areaAggregateQueryFn)
                    ]
                },
                {
                    id: '7ebedabb-be04-4d54-9775-6a48e6d514d4',
                    title: 'Erosion Severity (Observed)',
                    sections: [
                        section(report, {
                            uuid: '86db4e0e-610c-4794-b4cb-2802a2b3e001'/*,
                            notebookViews: defaultViews(report, IDS.EROSION)*/
                        }, IDS.EROSION, areaAggregateQueryFn)
                    ]
                },
                {
                    id: '90abee75-21f2-4cee-a6fe-76b8b577e7c0',
                    title: 'Surface Rock Type',
                    sections: [
                        section(report, {
                            uuid: 'f92fdc8f-295a-4ae1-abfb-f4eba918cf28'/*,
                            notebookViews: defaultViews(report, IDS.SURFACE_ROCK)*/
                        }, IDS.SURFACE_ROCK, areaAggregateQueryFn)
                    ]
                }
            ]
        },
        {
            title: 'Land Capability',
            topics: [
                {
                    id: '5119e41d-84f4-4fbe-a239-494367a06f2e',
                    title: 'Land Use Capability',
                    sections: [
                        section(report, {
                            uuid: 'd1b59a0a-1393-4000-93a0-925f6781e489'/*,
                            notebookViews: defaultViews(report, IDS.LUC_MAIN)*/
                        }, IDS.LUC_MAIN, areaAggregateQueryFn)
                    ]
                },
                {
                    id: "f878436c-e91b-4311-86e7-aeda20dd4655",
                    title: "Baseline Highly Productive Land",
                    sections: [
                        section(report, {
                            uuid: "f6cfa7a5-5a1d-49eb-88a2-621d432b5cb3" /*,
                            notebookViews: defaultViews(report, IDS.LUC_MAIN)*/
                        }, IDS.LRI_HPL_LAND, areaAggregateQueryFn)
                    ]
                },
                {
                    id: '72ee867d-a20e-44c0-ac57-09b994149475',
                    title: 'Suitability for Arable Cropping',
                    sections: [
                        section(report, {
                            uuid: '2459d364-10dd-4142-94d8-263682b6cea9'/*,
                            notebookViews: defaultViews(report, IDS.ARABLE_SUITABILITY)*/
                        }, IDS.ARABLE_SUITABILITY, areaAggregateQueryFn)
                    ]
                },
                {
                    id: '863e2977-46cd-4ee2-84b8-4c8a18ef2bc3',
                    title: 'General Suitability',
                    sections: [
                        section(report, {
                            uuid: '1fe167fc-d100-4332-a734-2db6843530ad'/*,
                            notebookViews: defaultViews(report, IDS.GENERAL_SUITABILITY)*/
                        }, IDS.GENERAL_SUITABILITY, areaAggregateQueryFn)
                    ]
                },
                {
                    id: 'e758f4a2-d23b-4fd5-a466-30d0d79203b9',
                    title: 'Suitability for Production Forestry',
                    sections: [
                        section(report, {
                            uuid: 'b9480c52-43d6-430f-bbe6-034583cd6d0e'/*,
                            notebookViews: defaultViews(report, IDS.PROD_FOR_SUITABILITY)*/
                        }, IDS.PROD_FOR_SUITABILITY, areaAggregateQueryFn)
                    ]
                },
                {
                    'id': 'b26f5515-bb08-437c-9153-e1b5f88a1358',
                    'title': 'Most intensive, sustainable land use possible',
                    sections: [
                        section(report, {
                            uuid: 'ad002cfb-881e-4381-b7c3-710aa5a3639b'/*,
                            notebookViews: defaultViews(report, IDS.LRI_PHYS_SUSTAIN)*/
                        }, IDS.LRI_PHYS_SUSTAIN, areaAggregateQueryFn)
                    ]
                }
            ]
        },
        {
            title: 'Habitats',
            topics: [
                {
                    'id': '4a1db66b-a1ab-4f20-9322-6aad44cd1e16',
                    title: 'Protected Areas Network',
                    sections: [
                        section(report, {
                            uuid: '125c0035-3c12-4a27-8780-92afc2c050ef'/*,
                            notebookViews: defaultViews(report, IDS.PROT_AREA_NET)*/
                        }, IDS.PROT_AREA_NET, areaAggregateQueryFn)
                    ]
                },
                {
                    id: '08850390-b322-456b-8342-6993a917a986',
                    title: 'Threatened Environment Classification',
                    sections: [
                        section(report, {
                            uuid: '38f9eace-acba-4b56-ba83-4b46345119bd'/*,
                            notebookViews: defaultViews(report, IDS.LENZ_TEC)*/
                        }, IDS.LENZ_TEC, areaAggregateQueryFn)
                    ]
                },
                {
                    'id': 'c5c90177-2660-483b-a61c-835dcde379bf',
                    'title': 'Potential Natural Vegetation',
                    sections: [
                        section(report, {
                            uuid: '80b45c7c-50ae-4dac-8703-fc4ea2ffed9e'/*,
                            notebookViews: defaultViews(report, IDS.POT_NAT_VEG)*/
                        }, IDS.POT_NAT_VEG, areaAggregateQueryFn)
                    ]
                },
                {
                    'id': '325c5656-0baf-4fb5-ad52-90da52405942',
                    'title': 'Vegetation',
                    sections: [
                        section(report, {
                            uuid: 'ed93ac67-9bba-4070-b9a7-7ed329fe5eba'/*,
                            notebookViews: defaultViews(report, IDS.VEG)*/
                        }, IDS.VEG, areaAggregateQueryFn)
                    ]
                },
                {
                    'id': 'ae48f295-b3e7-4828-a992-e82868b5512c',
                    'title': 'Wetlands',
                    sections: [
                        section(report, {
                            uuid: '1e7013a8-5a0b-4a71-a439-211fa00143f3',
                            title: 'Pre-human Wetlands'
                        }, IDS.WETLANDS_HISTORIC, areaAggregateQueryFn),
                        section(report, {
                            uuid: '71991690-7327-43fa-8935-67004d04d1f3',
                            'title': 'Current Wetlands'
                        }, IDS.WETLANDS_CURRENT, areaAggregateQueryFn)
                    ]
                }
            ]
        },
        {
            "id": "3ca37a83-e2e7-4924-a6df-9ad2021228eb",
            "title": "Ecosystem Characteristics",
            "topics": [
                {
                    'id': 'bdfaeba1-4aa1-43d3-abc9-0c9f65e539d3',
                    'title': 'Basic Ecosystems (2002-2008)',
                    sections: [
                        section(report, {
                            uuid: '007a6c71-5e0a-4ff3-8b91-f81ffb951ee5'/*,
                            notebookViews: defaultViews(report, IDS.BASIC_ECOSYS)*/
                        }, IDS.BASIC_ECOSYS, areaAggregateQueryFn)
                    ]
                },
                {
                    'id': '5819e3ee-2110-4083-a322-851ebb493268',
                    'title': 'Water Yield (2012)',
                    sections: [
                        section(report, {
                            uuid: 'a68eaa10-fc92-4fda-9e9c-8ac59568487c'/*,
                            notebookViews: defaultViews(report, IDS.ECOSYS_WATER_YIELD)*/
                        }, IDS.ECOSYS_WATER_YIELD, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "ff653425-1af7-4f50-9a1f-ba7598905319",
                    "title": "Sediment Lost (2012)",
                    sections: [
                        section(report, {
                            uuid: 'd4b5fcc3-05b7-40f8-97f2-b31de336b7db'/*,
                            notebookViews: defaultViews(report, IDS.ECOSYS_SEDTLOST)*/
                        }, IDS.ECOSYS_SEDTLOST, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "ac817de1-22ae-4af8-b868-150c61535f0f",
                    "title": "Sediment Retained (2012)",
                    sections: [
                        section(report, {
                            uuid: '635dad3c-a3dc-4d87-ba92-5a1b7831a14b'/*,
                            notebookViews: defaultViews(report, IDS.ECOSYS_SEDTRETAINED)*/
                        }, IDS.ECOSYS_SEDTRETAINED, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "a3960fe1-1641-4658-9d88-c10351ceea44",
                    "title": "Phosphorous loss susceptibility",
                    "layerId": 321,
                    "layerName": "eswwo_susceptibility_to_n_loss_horiz",
                    "sections": [section(report, {uuid: '191d212e-216d-4498-a185-b9326ca8c327'}, 321, areaAggregateQueryFn)]
                }, {
                    "id": "3be359d9-6754-44d6-aef7-f6958335f9de",
                    "title": "Nitrogen loss susceptibility",
                    "layerId": 322,
                    "layerName": "eswwo_susceptibility_to_n_loss_vert",
                    "sections": [section(report, {uuid: '253da64c-e433-4397-acce-7b3853372944'}, 322, areaAggregateQueryFn)]
                }
            ]
        },
        {
            title: "Crop Suitability",
            topics: [
                {
                    "id": "43b63444-9720-4fe8-b3e3-62fde3c1b094",
                    "title": "Apple Suitability Score",
                    "sections": [
                        section(report, {uuid: "f8de6783-4b7c-491a-873c-30a5eb208ff4"}, 291, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "3536e5f1-a2cc-4ea1-8868-9361e1ac35d6",
                    "title": "Avocado Suitability Score",
                    "sections": [
                        section(report, {uuid: "73c4ce4d-f5c1-4ffb-82fa-83b29adccbaf"}, 292, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "742f7d65-eb3b-4e8d-93ad-281df5c380e0",
                    "title": "Blueberry Suitability Score",
                    "sections": [
                        section(report, {uuid: "b5a0ca87-53c9-41ac-a6ae-665af5da3e98"}, 293, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "84a9de3e-e085-4ec1-9169-ff7ebd37253c",
                    "title": "Cherry Suitability Score",
                    "sections": [
                        section(report, {uuid: "e7ade83f-281b-42a2-9667-97597f777ce7"}, 294, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "4c6f989a-558e-4e10-879d-43f3ca314e1d",
                    "title": "Chestnuts Suitability Categories",
                    "sections": [
                        section(report, {uuid: "102324e1-acbc-4a8b-ac05-5f767a3a40fe"}, 295, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "524ee716-8810-4f72-9822-0564e898122d",
                    "title": "Citrus Suitability Categories",
                    "sections": [
                        section(report, {uuid: "7b499ed2-a821-4e6e-b642-32f03210ec9e"}, 296, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "56a120b1-d2e0-49e6-8f07-bdb38f6d9753",
                    "title": "Douglas Fir Suitability Categories",
                    "sections": [
                        section(report, {uuid: "33d328da-5c92-4535-b37b-56a9058dedfb"}, 297, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "3012630a-c6e3-4b9a-b591-a7a7c9b6d315",
                    "title": "Eucalyptus Fastigata Suitability Categories",
                    "sections": [
                        section(report, {uuid: "c4e3d504-b067-452e-bb35-ef3c993cfc6e"}, 298, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "c4921a65-553f-4bf8-86f8-1fe0e3a1f515",
                    "title": "Honey Manuka Suitability Categories",
                    "sections": [
                        section(report, {uuid: "d5060008-b879-4403-999b-e155da44d35c"}, 299, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "7f1f857e-c07b-41b7-8449-20439f323114",
                    "title": "Hops Suitability Categories",
                    "sections": [
                        section(report, {uuid: "5f5e2b0c-19fa-413a-9505-08a45e849212"}, 300, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "da843060-1857-4371-bf93-79e8477d5747",
                    "title": "Kiwifruit Suitability Score",
                    "sections": [
                        section(report, {uuid: "cd5df86d-6322-40a0-a96b-a762d3e49d13"}, 301, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "ebb1770c-992e-4f16-a5d1-702a06038cea",
                    "title": "Macadamia Suitability Categories",
                    "sections": [
                        section(report, {uuid: "80cf8e7a-765b-4efc-b121-f038b1250428"}, 302, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "4d4eb90b-1b41-4ed0-9a96-2f96b549147a",
                    "title": "Maize Grain Suitability Categories",
                    "sections": [
                        section(report, {uuid: "0865be58-eb26-4726-9aa3-e4b4bea2aee0"}, 303, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "b18a280b-7197-40af-8bd1-ce344859152b",
                    "title": "Onions Suitability Categories",
                    "sections": [
                        section(report, {uuid: "5a7fa7d1-fcc8-4530-b519-c3b281ccf0bd"}, 304, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "8bb9677a-2837-4ac9-99c6-49be5c833f4d",
                    "title": "Peas Suitability Categories",
                    "sections": [
                        section(report, {uuid: "6cde440b-ddbf-4610-817f-9390d3e15896"}, 305, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "0fc5a069-7a35-4af6-bc84-357b9b7951d2",
                    "title": "Potatoes Suitability Categories",
                    "sections": [
                        section(report, {uuid: "d57d4306-930e-463e-a8d4-7197f9abdf5e"}, 306, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "6c6921fa-76e9-4a7d-9d03-b82711172529",
                    "title": "Radiata Pine Suitability Categories",
                    "sections": [
                        section(report, {uuid: "daa2ec09-4a19-45d5-bb64-2f168e4efc83"}, 307, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "43dfde56-275a-493e-93e9-b869f56d0575",
                    "title": "Truffles Suitability Categories",
                    "sections": [
                        section(report, {uuid: "9184c5c2-7b34-468d-876d-abf65b90b51b"}, 308, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "4f74bbe8-9b7f-4441-8e56-e2d6c9db18ac",
                    "title": "Wheat Barley And Oats Suitability Categories",
                    "sections": [
                        section(report, {uuid: "d339eb5a-fa0b-41df-a479-00bb2fd6d6b0"}, 309, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "cf9666eb-749a-4de5-ba2d-89e189784e5c",
                    "title": "Wine Grape Pinot Noir Suitability Score",
                    "sections": [
                        section(report, {uuid: "fa636597-a427-42c3-a8ce-34b891e9a78f"}, 310, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "41742235-2f65-403b-b019-b2598222e8a5",
                    "title": "Wine Grape Sauvignon Blanc Suitability Score",
                    "sections": [
                        section(report, {uuid: "645913fe-67a4-4bfe-9985-92d66205ef0a"}, 311, areaAggregateQueryFn)
                    ]
                }
            ]
        },
        {
            "id": "8f1eb46f-bc4d-4bc6-8695-ee6dd57565f9",
            "title": "Agricultural Impacts",
            "topics": [
                {
                    "id": "63e7e247-3748-4fb5-a834-f2e6da6d8dd2",
                    "title": "Nitrate Leaching (2015)",
                    sections: [
                        section(report, {
                            uuid: "93bf5b92-40d8-4085-a357-04363505a61e"/*,
                            notebookViews: defaultViews(report, IDS.ECOSYS_NITRATE)*/
                        }, IDS.ECOSYS_NITRATE, areaAggregateQueryFn)
                    ]
                },
                {
                    'id': '341c91e7-1c81-427a-80e9-8b4c5f919500',
                    'title': 'Greenhouse gas emission (2010-2016)',
                    sections: [
                        section(report, {
                            uuid: "298239c1-c713-45eb-a872-90af302d490a"/*,
                            notebookViews: defaultViews(report, IDS.ECOSYS_GHG)*/
                        }, IDS.ECOSYS_GHG, areaAggregateQueryFn)
                    ]
                },
                {
                    "id": "75def429-195f-4155-a62b-df0264950bb8",
                    "title": "Dairy nitrogen loss",
                    "layerId": 312,
                    "layerName": "eswwo_dairy_max_n",
                    "sections": [section(report, {uuid: '71a374fd-3e32-48fc-b36d-ee86710068c2'}, 312, areaAggregateQueryFn)]
                }, {
                    "id": "ae44ec43-c688-4839-8fc9-0762890edf0b",
                    "title": "Dairy N₂O emissions",
                    "layerId": 313,
                    "layerName": "eswwo_dairy_max_n2o",
                    "sections": [section(report, {uuid: '2de7c909-1ab1-4eb8-95ec-40b3dd317ea4'}, 313, areaAggregateQueryFn)]
                },
                {
                    "id": "6a2ec580-05f9-462e-9b02-73e881563e73",
                    "title": "Estimated Nitrogen Leaching - Ryegrass and Silage Maize",
                    "layerId": 317,
                    "layerName": "eswwo_nleachloss_maize_grass",
                    "sections": [section(report, {uuid: 'be1fb6ea-c062-4d1c-94ba-d3dada322152'}, 317, areaAggregateQueryFn)]
                },
                {
                    "id": "192dfa15-3013-470c-ae2f-185496617d28",
                    "title": "Estimated Nitrogen Leaching - Intensive Vegetables",
                    "layerId": 316,
                    "layerName": "eswwo_nleachloss_intensive_veggies",
                    "sections": [section(report, {uuid: '5342ec83-213a-4763-a40f-a7d3fafacb12'}, 316, areaAggregateQueryFn)]
                },
                {
                    "id": "3abca607-4451-420c-8db9-3f637d6c1838",
                    "title": "Estimated Nitrogen Leaching - Broadacre Vegetables",
                    "layerId": 315,
                    "layerName": "eswwo_nleachloss_broadacre_veggies",
                    "sections": [section(report, {uuid: '0736a578-0da6-48c3-81ba-342014e33396'}, 315, areaAggregateQueryFn)]
                },
            ],
        },
        {
            "id": "c0edb64f-3919-4280-a113-d73f2f80f070",
            "title": "Freshwater State",
            "topics": [{
                "id": "07a8994f-411a-4b55-9525-7d64e10c28f1",
                "title": "E. coli excess load",
                "layerId": 314,
                "layerName": "eswwo_ecoli_exyldpct",
                "sections": [section(report, {uuid: 'bd20c8ec-6d25-4475-852b-0ab83fae49f9'}, 314, areaAggregateQueryFn)]
            }, {
                "id": "4ae1cb51-0e9b-4582-889a-c1ee7091f07b",
                "title": "Nitrogen excess load",
                "layerId": 318,
                "layerName": "eswwo_nutr_tn_exyldpct",
                "sections": [section(report, {uuid: '3c33f034-6e25-468b-882d-0cb1605c61f9'}, 318, areaAggregateQueryFn)]
            }, {
                "id": "9150f512-78be-4141-a6c3-8a270000cc5f",
                "title": "Phosphorus excess load",
                "layerId": 319,
                "layerName": "eswwo_nutr_tp_exyldpct",
                "sections": [section(report, {uuid: 'b1a025e0-9e55-4c63-a4ea-ab577e7b8397'}, 319, areaAggregateQueryFn)]
            }, {
                "id": "eedb796f-f6e1-49cb-a67e-7e0504f7da88",
                "title": "Sediment excess load",
                "layerId": 320,
                "layerName": "eswwo_sedi_exyldpct",
                "sections": [section(report, {uuid: '1c38a9b1-337a-4cfc-8ffb-36637455a072'}, 320, areaAggregateQueryFn)]
            }]
        }
    ];
}
